<span class="text-no-wrap">{{ timestamp * 1000|date }}</span>
